// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========== Shared ========== */

.Content_cardContent__0wUOy {
  width: 100%;
}

.Content_filterForm__P1s6e {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.Content_select__0k0RX {
  width: 280px !important;
}

.Content_sectionTitle__mgDZ4 {
  font-size: 18px;
  font-weight: 600;
  color: #383838;
  margin: 0 0 4px 0;
}

/* ========== Summary ========== */

.Content_summaryGrid__3SjIG {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.Content_summaryCard__4hxJv {
  background: #fff;
  border-radius: 14px;
  padding: 24px 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid #f5f5f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  position: relative;
  overflow: hidden;
}

.Content_summaryIconWrap__F31gL {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background-color: #fff3ec;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: var(--orange);
  margin-bottom: 4px;
}

.Content_summaryValue__ShbBd {
  font-size: 36px;
  font-weight: 300;
  color: var(--orange);
  margin: 0;
  line-height: 1.1;
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.Content_summaryValue__ShbBd span {
  font-size: 20px;
}

.Content_summaryLabel__Ld4NB {
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  color: #888;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* ========== TopProducts / OrdersArea Table ========== */

.Content_containerTable__YH9ja {
  background-color: #FFF;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border: 1px solid #f0f0f0;
  overflow: hidden;
}

.Content_containerTableArea__s4NWx {
  background-color: #FFF;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border: 1px solid #f0f0f0;
  overflow: hidden;
}

.Content_headerItemTable__JIlP3 {
  background: #fafafa;
  border-bottom: 1px solid #eee;
  border-right: 1px solid #f0f0f0;
  font-size: 11px;
  font-weight: 600;
  color: #888;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.Content_bodyCellTable__6PqIH {
  padding: 12px 8px;
  border-right: 1px solid #f5f5f5;
  border-bottom: 1px solid #f9f9f9;
  font-size: 14px;
  font-weight: 400;
  color: #444444;
  text-align: center;
}

.Content_lastHeaderItemTable__a0A8V {
  border-right: 0px;
}

.Content_bodyCellTable__6PqIH:last-of-type {
  border-right: 0px;
}

/* ========== CustomerTracking ========== */

.Content_itemDatePicker__MNpwT {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 24px;
}

.Content_totalOverview__ekGsv {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.Content_antCard__jC7lm {
  border-radius: 14px !important;
  border: 1px solid #f0f0f0 !important;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06) !important;
  background-color: #fff !important;
  overflow: hidden;
  position: relative;
}

.Content_antCard__jC7lm div {
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.Content_customerIcon__4H-ta {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background-color: #fff3ec;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}

.Content_customerIcon__4H-ta svg {
  width: 24px;
  height: 24px;
  color: var(--orange);
}

.Content_number__5QVmD {
  font-size: 40px;
  font-weight: 300;
  color: #383838;
  margin: 0;
  line-height: 1;
}

.Content_label__dPuPT {
  font-size: 12px;
  font-weight: 600;
  color: var(--orange);
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.Content_amount__oFZ4r {
  font-size: 48px;
  font-weight: 300;
  color: #383838;
  margin: 0;
  line-height: 1;
}

.Content_percentSuccess__FAsfW {
  font-size: 24px;
  font-weight: 500;
  color: #01B652;
  margin: 0;
}

.Content_percentFail__g0MEP {
  font-size: 24px;
  font-weight: 500;
  color: #FC4850;
  margin: 0;
}

.Content_indicator__B076h {
  font-size: 14px;
  font-weight: 600;
  color: #666;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.Content_amountPercent__Uhj9l {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 8px;
}

.Content_containerIndicators__\\+94Yl {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.Content_indicatorCard__NNmjO {
  background: #fff;
  border-radius: 14px;
  padding: 24px 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.Content_buttonListClient__DjOuU {
  border: 1px solid #d0d0d0;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #666;
  transition: all 0.25s ease;
}

.Content_buttonListClient__DjOuU:hover {
  border-color: var(--orange);
  color: var(--orange);
}

.Content_indicatorOverview__Oj6Q4 {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 12px;
}

.Content_divider__vk\\+zF {
  height: 100%;
}

/* ========== Average Times ========== */

.Content_legend__7ZF\\+f {
  font-size: 13px;
  font-weight: 400;
  color: #888;
  margin-top: 8px;
}

.Content_charts__joTv1 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  width: 100%;
}

.Content_chartCard__aek23 {
  background: #fff;
  border-radius: 14px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0f0f0;
}

.Content_chartCardTitle__y5XES {
  font-size: 15px;
  font-weight: 600;
  color: #383838;
  text-align: center;
  margin-bottom: 8px;
}

.Content_chartContent__DQHcD {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.Content_chartLegends__OnZIP {
  display: flex;
  gap: 20px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.Content_chartLegend__PqUTx {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #666;
}

.Content_chartLegendDot__3swao {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.Content_chartLegendDotAcceptance__S551k {
  background-color: #e0e0e0;
  border: 2px solid #bbb;
}

.Content_chartLegendDotPreparation__HZRIC {
  background-color: #585858;
}

.Content_chartLegendDotOnTheWay__QSA2j {
  background-color: var(--orange);
}

/* Keep old box styles for backward compat */

.Content_chartLegendBox__N6Swk {
  width: 22px;
  height: 22px;
  border: 1px;
  border: 1px solid #808080;
}

.Content_chartLegendBoxPreparation__76EET {
  background-color: #585858;
}

.Content_chartLegendBoxOnTheWay__RDsUp {
  background-color: #FF671D;
}

/* ========== TotalOverview ========== */

.Content_containerTotalOverviewCard__BcYSP {
  width: 100%;
  max-width: 100%;
  border-radius: 14px !important;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06) !important;
  border: 1px solid #f0f0f0 !important;
  overflow: hidden;
}

.Content_legendTotalOverview__roYUZ {
  font-size: 16px;
  font-weight: 600;
  color: #383838;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f5f5f5;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* ========== Chart containers shared ========== */

.Content_chartContainer__4ukDi {
  background: #fff;
  border-radius: 14px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0f0f0;
}

.Content_chartTitle__gqfgd {
  font-size: 16px;
  font-weight: 600;
  color: #383838;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f5f5f5;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* ========== OrdersSales ========== */

/* ========== OrdersPerHour ========== */

.Content_formOrders__\\+QAoK {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

/* ========== Heading (summary legacy) ========== */

.Content_gridCard__SOWVH {
  width: 100%;
  max-width: 100%;
}

.Content_heading__DGRTs {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 56px;
  font-weight: 400;
  color: var(--orange);
  margin: 0px;
}

.Content_heading__DGRTs p {
  position: relative;
  font-size: 25px;
  margin: 0px;
  top: 10px;
}

.Content_subheading__4tYpY {
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  color: #585858;
}

.Content_center__zRu4- {
  display: flex;
  justify-content: center;
}

/* ========== Responsive Media Queries ========== */

@media (max-width: 1200px) {
  .Content_summaryGrid__3SjIG {
    grid-template-columns: repeat(2, 1fr);
  }

  .Content_containerIndicators__\\+94Yl {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .Content_summaryGrid__3SjIG {
    grid-template-columns: 1fr;
  }

  .Content_totalOverview__ekGsv {
    grid-template-columns: 1fr;
  }

  .Content_containerIndicators__\\+94Yl {
    grid-template-columns: 1fr;
  }

  .Content_charts__joTv1 {
    grid-template-columns: 1fr;
  }

  .Content_filterForm__P1s6e form {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    gap: 8px;
  }

  .Content_filterForm__P1s6e .ant-form-item {
    margin: 0;
  }

  .Content_filterForm__P1s6e .ant-form-item:first-child {
    flex: 1 1;
    min-width: 0;
  }

  .Content_select__0k0RX {
    width: 100% !important;
  }

  .Content_containerTableArea__s4NWx {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/kpis/styles/Content.module.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACI,WAAW;AACf;;AAEA;EACI,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;AACvB;;AAEA;EACI,uBAAuB;AAC3B;;AAEA;EACI,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACrB;;AAEA,kCAAkC;;AAElC;EACI,aAAa;EACb,qCAAqC;EACrC,SAAS;AACb;;AAEA;EACI,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AACpB;;AAIA;EACI,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACtB;;AAEA;EACI,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACZ;;AAEA;EACI,eAAe;AACnB;;AAEA;EACI,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,yBAAyB;EACzB,qBAAqB;AACzB;;AAEA,yDAAyD;;AAEzD;EACI,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,qCAAqC;EACrC,yBAAyB;EACzB,gBAAgB;AACpB;;AAEA;EACI,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,qCAAqC;EACrC,yBAAyB;EACzB,gBAAgB;AACpB;;AAEA;EACI,mBAAmB;EACnB,6BAA6B;EAC7B,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACzB;;AAEA;EACI,iBAAiB;EACjB,+BAA+B;EAC/B,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACtB;;AAEA;EACI,iBAAiB;AACrB;;AAEA;EACI,iBAAiB;AACrB;;AAEA,2CAA2C;;AAE3C;EACI,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACvB;;AAEA;EACI,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACvB;;AAEA;EACI,8BAA8B;EAC9B,oCAAoC;EACpC,qDAAqD;EACrD,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACtB;;AAEA;EACI,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACtB;;AAEA;EACI,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACtB;;AAEA;EACI,WAAW;EACX,YAAY;EACZ,oBAAoB;AACxB;;AAEA;EACI,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,cAAc;AAClB;;AAEA;EACI,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;EACT,yBAAyB;EACzB,qBAAqB;AACzB;;AAEA;EACI,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,cAAc;AAClB;;AAEA;EACI,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACb;;AAEA;EACI,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACb;;AAEA;EACI,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,yBAAyB;EACzB,qBAAqB;AACzB;;AAEA;EACI,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,QAAQ;AACZ;;AAEA;EACI,aAAa;EACb,qCAAqC;EACrC,SAAS;AACb;;AAEA;EACI,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACb;;AAEA;EACI,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,0BAA0B;AAC9B;;AAEA;EACI,2BAA2B;EAC3B,oBAAoB;AACxB;;AAEA;EACI,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;AACb;;AAEA;EACI,YAAY;AAChB;;AAEA,wCAAwC;;AAExC;EACI,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACnB;;AAEA;EACI,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACf;;AAEA;EACI,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,yBAAyB;AAC7B;;AAEA;EACI,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACtB;;AAEA;EACI,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACf;;AAEA;EACI,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACnB;;AAEA;EACI,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;AACf;;AAEA;EACI,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAClB;;AAEA;EACI,yBAAyB;EACzB,sBAAsB;AAC1B;;AAEA;EACI,yBAAyB;AAC7B;;AAEA;EACI,+BAA+B;AACnC;;AAEA,4CAA4C;;AAC5C;EACI,WAAW;EACX,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC7B;;AAEA;EACI,yBAAyB;AAC7B;;AAEA;EACI,yBAAyB;AAC7B;;AAEA,wCAAwC;;AAExC;EACI,WAAW;EACX,eAAe;EACf,8BAA8B;EAC9B,qDAAqD;EACrD,oCAAoC;EACpC,gBAAgB;AACpB;;AAEA;EACI,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,yBAAyB;EACzB,qBAAqB;AACzB;;AAEA,kDAAkD;;AAElD;EACI,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,yBAAyB;AAC7B;;AAEA;EACI,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,yBAAyB;EACzB,qBAAqB;AACzB;;AAEA,sCAAsC;;AAEtC,wCAAwC;;AAExC;EACI,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,eAAe;EACf,mBAAmB;AACvB;;AAEA,mDAAmD;;AAEnD;EACI,WAAW;EACX,eAAe;AACnB;;AAEA;EACI,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACf;;AAEA;EACI,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,SAAS;AACb;;AAEA;EACI,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAClB;;AAEA;EACI,aAAa;EACb,uBAAuB;AAC3B;;AAEA,mDAAmD;;AAEnD;EACI;IACI,qCAAqC;EACzC;;EAEA;IACI,qCAAqC;EACzC;AACJ;;AAEA;EACI;IACI,0BAA0B;EAC9B;;EAEA;IACI,0BAA0B;EAC9B;;EAEA;IACI,0BAA0B;EAC9B;;EAEA;IACI,0BAA0B;EAC9B;;EAEA;IACI,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,QAAQ;EACZ;;EAEA;IACI,SAAS;EACb;;EAEA;IACI,SAAO;IACP,YAAY;EAChB;;EAEA;IACI,sBAAsB;EAC1B;;EAEA;IACI,0BAA0B;EAC9B;AACJ","sourcesContent":["/* ========== Shared ========== */\n\n.cardContent {\n    width: 100%;\n}\n\n.filterForm {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n    margin-bottom: 20px;\n}\n\n.select {\n    width: 280px !important;\n}\n\n.sectionTitle {\n    font-size: 18px;\n    font-weight: 600;\n    color: #383838;\n    margin: 0 0 4px 0;\n}\n\n/* ========== Summary ========== */\n\n.summaryGrid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 16px;\n}\n\n.summaryCard {\n    background: #fff;\n    border-radius: 14px;\n    padding: 24px 20px;\n    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);\n    border: 1px solid #f5f5f5;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n    position: relative;\n    overflow: hidden;\n}\n\n\n\n.summaryIconWrap {\n    width: 48px;\n    height: 48px;\n    border-radius: 12px;\n    background-color: #fff3ec;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 22px;\n    color: var(--orange);\n    margin-bottom: 4px;\n}\n\n.summaryValue {\n    font-size: 36px;\n    font-weight: 300;\n    color: var(--orange);\n    margin: 0;\n    line-height: 1.1;\n    display: flex;\n    align-items: baseline;\n    gap: 4px;\n}\n\n.summaryValue span {\n    font-size: 20px;\n}\n\n.summaryLabel {\n    font-size: 12px;\n    font-weight: 600;\n    text-align: center;\n    color: #888;\n    margin: 0;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n/* ========== TopProducts / OrdersArea Table ========== */\n\n.containerTable {\n    background-color: #FFF;\n    border-radius: 12px;\n    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    border: 1px solid #f0f0f0;\n    overflow: hidden;\n}\n\n.containerTableArea {\n    background-color: #FFF;\n    border-radius: 12px;\n    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    border: 1px solid #f0f0f0;\n    overflow: hidden;\n}\n\n.headerItemTable {\n    background: #fafafa;\n    border-bottom: 1px solid #eee;\n    border-right: 1px solid #f0f0f0;\n    font-size: 11px;\n    font-weight: 600;\n    color: #888;\n    height: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.bodyCellTable {\n    padding: 12px 8px;\n    border-right: 1px solid #f5f5f5;\n    border-bottom: 1px solid #f9f9f9;\n    font-size: 14px;\n    font-weight: 400;\n    color: #444444;\n    text-align: center;\n}\n\n.lastHeaderItemTable {\n    border-right: 0px;\n}\n\n.bodyCellTable:last-of-type {\n    border-right: 0px;\n}\n\n/* ========== CustomerTracking ========== */\n\n.itemDatePicker {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 24px;\n}\n\n.totalOverview {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 16px;\n    margin-bottom: 24px;\n}\n\n.antCard {\n    border-radius: 14px !important;\n    border: 1px solid #f0f0f0 !important;\n    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06) !important;\n    background-color: #fff !important;\n    overflow: hidden;\n    position: relative;\n}\n\n.antCard div {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n}\n\n.customerIcon {\n    width: 44px;\n    height: 44px;\n    border-radius: 12px;\n    background-color: #fff3ec;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 4px;\n}\n\n.customerIcon svg {\n    width: 24px;\n    height: 24px;\n    color: var(--orange);\n}\n\n.number {\n    font-size: 40px;\n    font-weight: 300;\n    color: #383838;\n    margin: 0;\n    line-height: 1;\n}\n\n.label {\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--orange);\n    margin: 0;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.amount {\n    font-size: 48px;\n    font-weight: 300;\n    color: #383838;\n    margin: 0;\n    line-height: 1;\n}\n\n.percentSuccess {\n    font-size: 24px;\n    font-weight: 500;\n    color: #01B652;\n    margin: 0;\n}\n\n.percentFail {\n    font-size: 24px;\n    font-weight: 500;\n    color: #FC4850;\n    margin: 0;\n}\n\n.indicator {\n    font-size: 14px;\n    font-weight: 600;\n    color: #666;\n    margin: 0;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n}\n\n.amountPercent {\n    display: flex;\n    align-items: baseline;\n    justify-content: center;\n    gap: 8px;\n}\n\n.containerIndicators {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 16px;\n}\n\n.indicatorCard {\n    background: #fff;\n    border-radius: 14px;\n    padding: 24px 16px;\n    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);\n    border: 1px solid #f0f0f0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n}\n\n.buttonListClient {\n    border: 1px solid #d0d0d0;\n    border-radius: 8px;\n    font-size: 12px;\n    font-weight: 500;\n    color: #666;\n    transition: all 0.25s ease;\n}\n\n.buttonListClient:hover {\n    border-color: var(--orange);\n    color: var(--orange);\n}\n\n.indicatorOverview {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.divider {\n    height: 100%;\n}\n\n/* ========== Average Times ========== */\n\n.legend {\n    font-size: 13px;\n    font-weight: 400;\n    color: #888;\n    margin-top: 8px;\n}\n\n.charts {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20px;\n    width: 100%;\n}\n\n.chartCard {\n    background: #fff;\n    border-radius: 14px;\n    padding: 24px;\n    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);\n    border: 1px solid #f0f0f0;\n}\n\n.chartCardTitle {\n    font-size: 15px;\n    font-weight: 600;\n    color: #383838;\n    text-align: center;\n    margin-bottom: 8px;\n}\n\n.chartContent {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n}\n\n.chartLegends {\n    display: flex;\n    gap: 20px;\n    margin-bottom: 16px;\n    flex-wrap: wrap;\n}\n\n.chartLegend {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 13px;\n    color: #666;\n}\n\n.chartLegendDot {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n\n.chartLegendDotAcceptance {\n    background-color: #e0e0e0;\n    border: 2px solid #bbb;\n}\n\n.chartLegendDotPreparation {\n    background-color: #585858;\n}\n\n.chartLegendDotOnTheWay {\n    background-color: var(--orange);\n}\n\n/* Keep old box styles for backward compat */\n.chartLegendBox {\n    width: 22px;\n    height: 22px;\n    border: 1px;\n    border: 1px solid #808080;\n}\n\n.chartLegendBoxPreparation {\n    background-color: #585858;\n}\n\n.chartLegendBoxOnTheWay {\n    background-color: #FF671D;\n}\n\n/* ========== TotalOverview ========== */\n\n.containerTotalOverviewCard {\n    width: 100%;\n    max-width: 100%;\n    border-radius: 14px !important;\n    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06) !important;\n    border: 1px solid #f0f0f0 !important;\n    overflow: hidden;\n}\n\n.legendTotalOverview {\n    font-size: 16px;\n    font-weight: 600;\n    color: #383838;\n    margin-bottom: 16px;\n    padding-bottom: 12px;\n    border-bottom: 2px solid #f5f5f5;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n/* ========== Chart containers shared ========== */\n\n.chartContainer {\n    background: #fff;\n    border-radius: 14px;\n    padding: 24px;\n    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);\n    border: 1px solid #f0f0f0;\n}\n\n.chartTitle {\n    font-size: 16px;\n    font-weight: 600;\n    color: #383838;\n    margin-bottom: 20px;\n    padding-bottom: 12px;\n    border-bottom: 2px solid #f5f5f5;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n/* ========== OrdersSales ========== */\n\n/* ========== OrdersPerHour ========== */\n\n.formOrders {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    flex-wrap: wrap;\n    margin-bottom: 20px;\n}\n\n/* ========== Heading (summary legacy) ========== */\n\n.gridCard {\n    width: 100%;\n    max-width: 100%;\n}\n\n.heading {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 56px;\n    font-weight: 400;\n    color: var(--orange);\n    margin: 0px;\n}\n\n.heading p {\n    position: relative;\n    font-size: 25px;\n    margin: 0px;\n    top: 10px;\n}\n\n.subheading {\n    font-size: 14px;\n    font-weight: 500;\n    text-align: center;\n    color: #585858;\n}\n\n.center {\n    display: flex;\n    justify-content: center;\n}\n\n/* ========== Responsive Media Queries ========== */\n\n@media (max-width: 1200px) {\n    .summaryGrid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n    \n    .containerIndicators {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 768px) {\n    .summaryGrid {\n        grid-template-columns: 1fr;\n    }\n    \n    .totalOverview {\n        grid-template-columns: 1fr;\n    }\n    \n    .containerIndicators {\n        grid-template-columns: 1fr;\n    }\n    \n    .charts {\n        grid-template-columns: 1fr;\n    }\n    \n    .filterForm form {\n        display: flex;\n        flex-wrap: nowrap;\n        width: 100%;\n        gap: 8px;\n    }\n\n    .filterForm :global(.ant-form-item) {\n        margin: 0;\n    }\n\n    .filterForm :global(.ant-form-item:first-child) {\n        flex: 1;\n        min-width: 0;\n    }\n\n    .select {\n        width: 100% !important;\n    }\n\n    .containerTableArea {\n        grid-template-columns: 1fr;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardContent": `Content_cardContent__0wUOy`,
	"filterForm": `Content_filterForm__P1s6e`,
	"select": `Content_select__0k0RX`,
	"sectionTitle": `Content_sectionTitle__mgDZ4`,
	"summaryGrid": `Content_summaryGrid__3SjIG`,
	"summaryCard": `Content_summaryCard__4hxJv`,
	"summaryIconWrap": `Content_summaryIconWrap__F31gL`,
	"summaryValue": `Content_summaryValue__ShbBd`,
	"summaryLabel": `Content_summaryLabel__Ld4NB`,
	"containerTable": `Content_containerTable__YH9ja`,
	"containerTableArea": `Content_containerTableArea__s4NWx`,
	"headerItemTable": `Content_headerItemTable__JIlP3`,
	"bodyCellTable": `Content_bodyCellTable__6PqIH`,
	"lastHeaderItemTable": `Content_lastHeaderItemTable__a0A8V`,
	"itemDatePicker": `Content_itemDatePicker__MNpwT`,
	"totalOverview": `Content_totalOverview__ekGsv`,
	"antCard": `Content_antCard__jC7lm`,
	"customerIcon": `Content_customerIcon__4H-ta`,
	"number": `Content_number__5QVmD`,
	"label": `Content_label__dPuPT`,
	"amount": `Content_amount__oFZ4r`,
	"percentSuccess": `Content_percentSuccess__FAsfW`,
	"percentFail": `Content_percentFail__g0MEP`,
	"indicator": `Content_indicator__B076h`,
	"amountPercent": `Content_amountPercent__Uhj9l`,
	"containerIndicators": `Content_containerIndicators__+94Yl`,
	"indicatorCard": `Content_indicatorCard__NNmjO`,
	"buttonListClient": `Content_buttonListClient__DjOuU`,
	"indicatorOverview": `Content_indicatorOverview__Oj6Q4`,
	"divider": `Content_divider__vk+zF`,
	"legend": `Content_legend__7ZF+f`,
	"charts": `Content_charts__joTv1`,
	"chartCard": `Content_chartCard__aek23`,
	"chartCardTitle": `Content_chartCardTitle__y5XES`,
	"chartContent": `Content_chartContent__DQHcD`,
	"chartLegends": `Content_chartLegends__OnZIP`,
	"chartLegend": `Content_chartLegend__PqUTx`,
	"chartLegendDot": `Content_chartLegendDot__3swao`,
	"chartLegendDotAcceptance": `Content_chartLegendDotAcceptance__S551k`,
	"chartLegendDotPreparation": `Content_chartLegendDotPreparation__HZRIC`,
	"chartLegendDotOnTheWay": `Content_chartLegendDotOnTheWay__QSA2j`,
	"chartLegendBox": `Content_chartLegendBox__N6Swk`,
	"chartLegendBoxPreparation": `Content_chartLegendBoxPreparation__76EET`,
	"chartLegendBoxOnTheWay": `Content_chartLegendBoxOnTheWay__RDsUp`,
	"containerTotalOverviewCard": `Content_containerTotalOverviewCard__BcYSP`,
	"legendTotalOverview": `Content_legendTotalOverview__roYUZ`,
	"chartContainer": `Content_chartContainer__4ukDi`,
	"chartTitle": `Content_chartTitle__gqfgd`,
	"formOrders": `Content_formOrders__+QAoK`,
	"gridCard": `Content_gridCard__SOWVH`,
	"heading": `Content_heading__DGRTs`,
	"subheading": `Content_subheading__4tYpY`,
	"center": `Content_center__zRu4-`
};
export default ___CSS_LOADER_EXPORT___;
